export default __webpack_public_path__ + "static/media/ios.579ac810.svg";